import React, { PureComponent, Fragment, createRef } from 'react'
import { connect } from 'react-redux'
import qs from 'query-string'
import moment from 'moment'

import { CircularProgress, Snackbar, Button } from '@material-ui/core'

import './style/index.scss'

// actions

import { closeMessage, openErrorMessage } from './actions/message'
import { renewSession, reviewCompanyAgreement, showSessionTimeoutModal } from './actions/auth'

// utils

import { logOut, isLoggedIn, getDocuSign } from './utils/api'

// local components

import Routes from './Routes'
import TimeoutModal from './components/common/TimeoutModal'
import DocusignModal from './components/Modal/DocusignModal'
import DocusignNotificationModal from './components/Modal/DocusignNotificationModal'
import { saveCompanyAgreement } from './actions/company'

class App extends PureComponent {
  constructor(props) {
    super(props)
    const searchParams = window.location.search
    const queryParams = qs.parse(searchParams)
    if (queryParams.action === 'logout') {
      logOut()
    }
    this.timeout = null
    this.state = {
      showDocusignModal: false,
      docuRes: {},
    }
  }

  docusignNotificationModal = createRef()

  componentDidMount() {
    let { session } = this.props.authReducer
    if (session) {
      let employee = session.employee || {}
      this.props.dispatch(reviewCompanyAgreement(employee.email || '', '')).then((docuRes) => {
        if (docuRes && docuRes.timeout) {
          this.setState({ docuRes: docuRes })
          if (docuRes.admin) {
            this.setState({
              showDocusignModal: true,
            })
          } else {
            this.docusignNotificationModal.current.handleClickOpen()
          }
        } else {
          const { expirationTime } = session || {}
          const exp = expirationTime - moment().valueOf() - 60 * 20000

          if (docuRes && docuRes.admin) {
            this.setState({
              docuRes: docuRes,
              showDocusignModal: true,
            })
          }

          if (exp > 0) {
            localStorage.setItem('time', 1200000)
            this.timeout = setTimeout(() => {
              if (isLoggedIn()) {
                this.props.dispatch(showSessionTimeoutModal(true))
              } else if (this.timeout) {
                clearTimeout(this.timeout)
              }
            }, exp)
          } else if (
            expirationTime - moment().valueOf() > 0 &&
            expirationTime - moment().valueOf() < 1200000
          ) {
            if (isLoggedIn()) {
              localStorage.setItem('time', expirationTime - moment().valueOf())
              this.props.dispatch(showSessionTimeoutModal(true))
            }
          } else {
            // this.onLogout();
          }
        }
      })
    }
    if (window.Appcues) {
      window.Appcues.start()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentPageReducer.routeTitle !== nextProps.currentPageReducer.routeTitle) {
      if (document) {
        document.title = nextProps.currentPageReducer.routeTitle
      }

      const docuSign = getDocuSign()
      if (docuSign && docuSign.endDate <= new Date().valueOf()) {
        let { session } = this.props.authReducer
        if (session) {
          let employee = session.employee || {}
          this.props.dispatch(reviewCompanyAgreement(employee.email || '', '')).then((docuRes) => {
            if (docuRes && docuRes.timeout) {
              this.setState({ docuRes: docuRes })
              if (docuRes.admin) {
                this.setState({
                  showDocusignModal: true,
                })
              } else {
                this.docusignNotificationModal.current.handleClickOpen()
              }
            } else {
              localStorage.removeItem('docuSign')
            }
          })
        }
      }
    }
    if (
      this.props.authReducer.showSessionTimeoutModal !==
      nextProps.authReducer.showSessionTimeoutModal
    ) {
      if (nextProps.authReducer.showSessionTimeoutModal) {
        this.sessionTimeoutModal.handleClickOpen()
      } else {
        this.sessionTimeoutModal.handleClose()
      }
    }
  }

  handleMessageClose = () => {
    this.props.dispatch(closeMessage())
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  onLogout = () => {
    logOut().then((res) => {
      this.props.dispatch(showSessionTimeoutModal(false))
      window.location.href = '/'
    })
  }

  onRenew = () => {
    //renew session here
    this.props.dispatch(renewSession()).then((res) => {
      localStorage.removeItem('time')
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      const { expirationTime } = res || {}
      const exp = expirationTime - moment().valueOf() - 60000 * 10

      this.timeout = setTimeout(() => {
        this.props.dispatch(showSessionTimeoutModal(true))
      }, exp)
      this.props.dispatch(showSessionTimeoutModal(false))
    })
  }

  onDocusignAccept = (agreement) => {
    this.setState({ showDocusignModal: false })
    if (agreement.status == 'agreed') {
      this.props
        .dispatch(saveCompanyAgreement(this.state.docuRes.userId, agreement.clickwrapId))
        .then((res) => {
          window.location.reload()
        })
    }
  }

  onDocusignDecline = (agreement) => {
    this.setState({ showDocusignModal: false })
    if (this.state.docuRes.timeout) {
      this.onLogout()
    }
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  render() {
    const { openMessage = false, message = '', type = 'error' } = this.props.messageReducer

    const { loading = false } = this.props.loadingReducer

    const { docuRes = {}, showDocusignModal = false } = this.state

    return (
      <Fragment>
        <Routes />
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={openMessage}
          autoHideDuration={6000}
          onClose={this.handleMessageClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <div className="center-aligned-child">
              <i
                className="material-icons"
                style={{
                  fontSize: 20,
                  marginRight: 15,
                }}
              >
                {type === 'success' ? 'check' : 'warning'}
              </i>
              {message}
            </div>
          }
          action={[
            <Button key="undo" color="secondary" size="small" onClick={this.handleMessageClose}>
              <i className="material-icons">close</i>
            </Button>,
          ]}
        />
        {loading ? (
          <div id="loader">
            <CircularProgress
              style={{
                color: 'white',
              }}
            />
          </div>
        ) : null}

        <TimeoutModal
          ref={(c) => (this.sessionTimeoutModal = c)}
          cancelText="Logout"
          confirmText="Renew"
          disableBackdropClick={true}
          title="Session Timed Out"
          onCancel={this.onLogout}
          onConfirm={this.onRenew}
        />

        {showDocusignModal && (
          <DocusignModal
            onAccept={this.onDocusignAccept}
            onDecline={this.onDocusignDecline}
            docuRes={docuRes}
          />
        )}

        <DocusignNotificationModal
          ref={this.docusignNotificationModal}
          docuRes={docuRes}
          onClose={this.onLogout}
        />
      </Fragment>
    )
  }
}

export default connect((state) => ({
  messageReducer: state.messageReducer,
  loadingReducer: state.loadingReducer,
  authReducer: state.authReducer,
  currentPageReducer: state.currentPageReducer,
  dispatch: state.dispatch,
}))(App)



// WEBPACK FOOTER //
// ./src/App.js